<!-- eslint-disable vue/no-v-html -->
<template>
  <section class="JoszakiHtmlTextBlock" v-html="processedHtml" />
</template>

<script>
export default {
  name: "JoszakiHtmlTextBlock",
  props: {
    text: {
      type: String,
      required: true,
    },
    openLinksInNewTab: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    processedHtml() {
      if (!this.text) return "";

      let parser, doc;

      if (process.client) {
        // Client-side: use browser's DOMParser
        parser = new DOMParser();
        doc = parser.parseFromString(this.text, "text/html");
      } else {
        // Server-side: use linkedom
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const { DOMParser } = require("linkedom");
        parser = new DOMParser();
        doc = parser.parseFromString(this.text, "text/html");
      }

      // Set IDs on h2
      doc.querySelectorAll("h2").forEach((el) => {
        el.id = this.$helpers.stringToSlug(el.textContent);
      });

      // Open links in new tab
      if (this.openLinksInNewTab) {
        doc.querySelectorAll("a").forEach((el) => {
          el.setAttribute("target", "_blank");
        });
      }

      // Lazy load images
      doc.querySelectorAll("img").forEach((el) => {
        el.setAttribute("loading", "lazy");
      });

      // Serialize back to string
      return doc.body.innerHTML;
    },
  },
};
</script>

<style lang="scss">
.JoszakiHtmlTextBlock {
  font-family: Nunito, sans-serif;

  @media only screen and (max-width: 768px) {
    overflow-x: scroll;
  }

  h1 {
    @apply text-2xl lg:text-4xl pt-2 pb-1 font-bold text-primary;
  }

  h2 {
    @apply text-xl lg:text-3xl pt-2 pb-1 font-bold text-primary;
  }

  h3 {
    @apply text-lg lg:text-2xl pt-2 pb-1 font-bold text-primary;
  }

  h4 {
    @apply text-base lg:text-xl pt-2 pb-1 font-bold text-primary;
  }

  h5 {
    @apply text-base lg:text-lg pt-2 pb-1 font-semibold text-primary;
  }

  p {
    margin-top: 0.5rem;
    text-align: justify;
  }

  img {
    margin-top: 10px;
    @apply md:max-w-[450px] md:mx-auto;
  }

  & > ul,
  & > ol {
    margin-top: 15px;
    margin-bottom: 25px;

    & > li {
      font-family: Nunito, sans-serif;
      margin-left: 20px;

      list-style-type: disc;
      list-style-position: outside;
    }
  }

  & > ol > li {
    list-style-type: decimal;
  }

  table {
    @apply w-full border-collapse mb-4 bg-white;

    th,
    td {
      @apply border border-gray-300 px-2 md:px-3 py-2 align-middle text-sm;
    }

    tr {
      @apply hover:bg-gray-100;
    }

    tr.category-header {
      @apply bg-primary-light text-white font-bold text-center;
    }
  }

  blockquote {
    @apply bg-white p-4 border border-gray-300 border-l-4 border-l-primary-light my-4;
    p {
      margin-top: 0;
    }
  }

  &.bg-primary * {
    color: white !important;
  }
}
</style>
